<template>
  <div class='logisticsConfig'>
    <div class='nav'>
      <el-form :model='form' label-width='100px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='线路名称:'>
          <el-input v-model='form.lineName' size='mini' placeholder='请输入线路名称'></el-input>
        </el-form-item>
        <el-form-item label='线路类型:'>

          <el-select v-model='form.lineType' filterable size='mini' placeholder='请选择线路类型'>
            <el-option label='全部' value=''></el-option>
            <el-option label='公路' value='1'></el-option>
            <el-option label='水路' value='2'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='起始地:'>
          <el-input v-model='form.startAddressName' size='mini' placeholder='请输入线路起运地'></el-input>
        </el-form-item>
        <el-form-item label='目的地:'>
          <el-input v-model='form.endAddressName' size='mini' placeholder='请输入线路目的地'></el-input>
        </el-form-item>
        <el-form-item label='起始港:'>
          <el-input v-model='form.departurePort' size='mini' placeholder='请输入起始港'></el-input>
        </el-form-item>
        <el-form-item label='到达港:'>
          <el-input v-model='form.arrivePort' size='mini' placeholder='请输入到达港'></el-input>
        </el-form-item>

        <!-- <el-form-item label="合同状态:">
          <el-select v-model="form.status" filterable size="mini" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用中" value="1"></el-option>
            <el-option label="禁用中" value="0"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <!-- <span @click="downLoad">下载模板</span>
          <span style="cursor: pointer">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="uploadUrl"
                :auto-upload="true"
                :show-file-list="false"
                :data="uploadData"
                :on-success="planOnSuccess"
                :before-upload="beforeUpload"
              >
                <i class="el-icon-upload el-icon--right">批量导入</i>
              </el-upload>
          </span> -->
          <span @click='exportClick'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
        >
          <el-table-column label='序号' align='center' width='50px'>
            <div slot-scope='scope'>{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop='lineName' label='线路名称' min-width='150' align='center' />
          <el-table-column prop='lineType' label='线路类型' width='80px' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.lineType | typeFilter }}
            </template>
          </el-table-column>
          <el-table-column prop='startAddressName' label='起运地' min-width='160' align='center'
                           :formatter='getStart'>
            <!-- <template slot-scope="scope">
              {{getStart(scope.row)}}
            </template> -->
          </el-table-column>
          <el-table-column prop='endAddressName' label='目的地' min-width='160' align='center'
                           :formatter='getEnd'>
            <!-- {{getEnd(scope.row)}} -->
          </el-table-column>
          <!-- <el-table-column prop="departurePort" label="起运港名" align="center"/>
          <el-table-column prop="arrivePort" label="到达港名" align="center"/> -->
          <el-table-column prop='estimateTime' label='耗时' width='70px' align='center'>
            <template slot-scope='scope'>{{ scope.row.estimateTime }}{{ scope.row.timeUnit }}
            </template>
          </el-table-column>
          <el-table-column prop='distance' label='距离(km)' width='80px' align='center' />
          <el-table-column prop='status' label='状态' width='80px' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.status |statusFilter }}
            </template>
          </el-table-column>
          <el-table-column label='操作' width='280' align='center'>
            <template slot-scope='scope'>
              <div>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row)'>详情
                </el-button>
                <el-button size='mini' type='danger' @click='DisableClick(scope.row)'
                           v-if='scope.row.status ==1 '>禁用
                </el-button>
                <el-button size='mini' type='primary' @click='EnableClick(scope.row)'
                           v-if='scope.row.status ==0 '>启用
                </el-button>
                <el-button size='mini' class='yellow-bg' @click='modifyClick(scope.row)'>修改
                </el-button>
                <el-button size='mini' type='info' @click='deleteClick(scope.row)'>删除</el-button>

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>

    <el-dialog :title='dialogTitle' :visible.sync='addflag' width='623px' center
               @close='dialogClose'>
      <div class='add'>
        <el-form :model='addform' label-width='100px' :rules='rules' ref='ruleForm'
                 class='demo-ruleForm'>
          <div-border label='基础信息'>
            <div>
              <el-form-item label='线路名称:' style='margin-top:15px;' prop='lineName'>
                <el-input v-model='addform.lineName' size='mini' placeholder='请输入维修内容'></el-input>
              </el-form-item>
              <el-form-item label='线路类型:' prop='lineType'>
                <el-radio-group v-model='addform.lineType' @change='lineTypeChange'>
                  <el-radio :label='1'>公路</el-radio>
                  <el-radio :label='2'>水路</el-radio>
                  <!-- <el-radio :label="3">水陆联运</el-radio> -->
                </el-radio-group>
              </el-form-item>
            </div>
          </div-border>
          <div-border label='选择线路' v-if='addform.lineType !==3'>
            <div>
              <el-form-item label='起始地区:' prop='startAddress'>
                <el-cascader
                  size='mini'
                  style='width: calc(100% - 160px)'
                  v-model='addform.startAddress'
                  placeholder='请选择起始地城市'
                  :options='cityList'
                  :props="{value: 'id', label:'cityName', children: 'children'}"
                  clearable filterable
                  ref='cascader1'
                  @change='handleChange(0,addform.startAddress)'>
                </el-cascader>
                <el-select v-if='addform.lineType==2' filterable @change='$forceUpdate()'
                           size='mini' v-model='addform.startPort'
                           style='width:150px;margin-left:10px;height:40px;' placeholder='请选择港口'>
                  <el-option v-for='item in startPortList' :key='item.id'
                             :label='item.supplier_name' :value='item.id'></el-option>
                </el-select>
              </el-form-item>
              <el-select v-if='addform.lineType!=2' filterable @change='$forceUpdate()' size='mini'
                         v-model='addform.startPort'
                         style='width:150px;position:absolute;right:10px;top:7px;'
                         placeholder='请选择港口'>
                <el-option v-for='item in startPortList' :key='item.id' :label='item.supplier_name'
                           :value='item.id'></el-option>
              </el-select>
              <el-form-item label='目的地区:' prop='endAddress'>
                <el-cascader
                  size='mini'
                  style='width: calc(100% - 160px)'
                  v-model='addform.endAddress'
                  ref='cascader2'
                  placeholder='请选择目的地城市'
                  :options='cityList'
                  :props="{value: 'id', label:'cityName', children: 'children'}"
                  clearable filterable
                  @change='handleChange(1,addform.endAddress)'>
                </el-cascader>
                <el-select v-if='addform.lineType==2' filterable @change='$forceUpdate()'
                           size='mini' v-model='addform.endPort'
                           style='width: 150px;margin-left:10px;height:40px;' placeholder='请选择港口'>
                  <el-option v-for='item in endPortList' :key='item.id' :label='item.supplier_name'
                             :value='item.id'></el-option>
                </el-select>
              </el-form-item>
              <el-select v-if='addform.lineType!=2' filterable @change='$forceUpdate()' size='mini'
                         v-model='addform.endPort'
                         style='width:150px;position:absolute;right:10px;top:57px;'
                         placeholder='请选择港口'>
                <el-option v-for='item in endPortList' :key='item.id' :label='item.supplier_name'
                           :value='item.id'></el-option>
              </el-select>
              <div class='estimated'>
                <el-form-item label='预计耗时:' prop='estimateTime'>
                  <el-input v-model='addform.estimateTime' size='mini' placeholder='请输入预计耗时多少'
                            style='margin-top: 7px'>
                    <el-select v-model='addform.repairContent' filterable slot='append'
                               placeholder='请选择'
                               ref='selectValue'>
                      <el-option label='时' value='时'></el-option>
                      <el-option label='天' value='天'></el-option>
                      <el-option label='周' value='周'></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </div>
              <el-form-item label='距离(km):' style='margin-bottom:15px;' prop='distance'>
                <el-input v-model='addform.distance' size='mini' placeholder='请输入距离'></el-input>
              </el-form-item>
            </div>
          </div-border>
          <div-border label='选择线路' v-if='addform.lineType ===3'>
            <div class='repair'>
              <div class='repairBotem'>
                <el-button size='mini' type='primary' @click='addStep'>添加</el-button>
                <el-button size='mini' type='danger' @click='clearStep'>删除</el-button>
                <el-button size='mini' type='info' @click='reset'>重置</el-button>

              </div>
              <div class='repairSteps'>
                <el-steps direction='vertical' :space='65'>
                  <el-step v-for='(item,index) in stepList' :key='`${index}n`'>

                    <div slot='title' v-if='index%2===0 '>

                      <!--                      {{item.address_type |endAddressTypeName}}-->
                    </div>
                    <div slot='icon' v-if='index%2 !==0'>
                      <el-select v-model='item.lineType' filterable size='mini' placeholder='选择类型'
                                 @change='lineTypeSelectChange(item.lineType,index)' value-key='id'>
                        <el-option v-for='(item,index) in item.lineTypeList'
                                   :label='`${item.lineName}-${item.lineTypeStr}`' :value='item.id'
                                   :key='`${index}cc`'>
                          <span style='float: left'>{{ item.lineName }}</span>
                          <span
                            style='float: right; color: #8492a6; font-size: 13px'>{{ item.lineTypeStr
                            }}</span>
                        </el-option>
                      </el-select>
                    </div>
                    <div slot='description' v-if='index%2===0 '>
                      {{ item.Address.name }}
                    </div>
                  </el-step>

                </el-steps>
              </div>
              <div class='estimated'>
                <el-form-item label='预计耗时:' prop='estimateTime'>
                  <el-input v-model='addform.estimateTime' size='mini' placeholder='请输入预计耗时多少'
                            style='margin-top: 7px'>
                    <el-select v-model='addform.repairContent' filterable slot='append'
                               placeholder='请选择'
                               ref='selectValue'>
                      <el-option label='时' value='时'></el-option>
                      <el-option label='天' value='天'></el-option>
                      <el-option label='周' value='周'></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </div>
              <el-form-item label='距离(km):' style='margin-bottom:15px;' prop='distance'>
                <el-input v-model='addform.distance' size='mini' placeholder='请输入距离'></el-input>
              </el-form-item>
            </div>
          </div-border>
        </el-form>
        <div class='btnContainer'>
          <el-button size='medium' class='searchBtn' :loading='addLoading' @click='addClick'>
            {{ dilogNumber === 1 ? '添加' : '修改' }}
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='623px' center>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.stateStr }}</p>
          </div>
          <el-form :model='detailData' label-position='left'>
            <div class='baseInfoContent'>
              <el-form-item label='线路名称:'>
                <span>{{ detailData.lineName }}</span>
              </el-form-item>
              <el-form-item label='线路类型:'>
                <span>{{ detailData.lineType |typeFilter }}</span>
              </el-form-item>
            </div>
            <!-- <div class="baseInfoTitle">
              <div class="line"/>
              <span>选择线路</span>
            </div> -->
            <div style='padding-left:20px' v-if='detailData.lineType !==3'>
              <el-form-item label='起始地:'>
                <span>{{ detailData.startAddressName
                  }}{{ detailData.departurePort ? ('【' + detailData.departurePort + '】') : ''
                  }}</span>
              </el-form-item>
              <el-form-item label='目的地:'>
                <span>{{ detailData.endAddressName
                  }}{{ detailData.arrivePort ? ('【' + detailData.arrivePort + '】') : '' }}</span>
              </el-form-item>
              <el-form-item label='预计耗时:'>
                <span>{{ `${detailData.estimateTime}${detailData.timeUnit}` }}</span>
              </el-form-item>
              <el-form-item label='距离(km):'>
                <span>{{ detailData.distance }}</span>
              </el-form-item>
            </div>
            <div class='baseInfoContent' v-if='detailData.lineType ===3'>
              <div class='repairSteps'>
                <el-steps direction='vertical' :space='65'>
                  <el-step v-for='(item,index) in stepList' :key='`${index}n`'>
                    <div slot='title' v-if='index%2===0 '>
                    </div>
                    <div slot='icon' v-if='index%2 !==0'>
                      <el-select v-model='item.lineType' filterable size='mini' placeholder='选择类型'
                                 @change='lineTypeSelectChange(item.lineType,index)' value-key='id'
                                 disabled>
                        <el-option v-for='(item,index) in item.lineTypeList'
                                   :label='`${item.lineName}-${item.lineTypeStr}`' :value='item.id'
                                   :key='`${index}cc`'>
                          <span style='float: left'>{{ item.lineName }}</span>
                          <span
                            style='float: right; color: #8492a6; font-size: 13px'>{{ item.lineTypeStr
                            }}</span>
                        </el-option>
                      </el-select>
                    </div>
                    <div slot='description' v-if='index%2===0 '>
                      {{ item.Address.name }}
                    </div>
                  </el-step>
                </el-steps>
              </div>
            </div>
          </el-form>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>操作记录</span>
            </div>
            <!--            :icon="activity.icon"-->
            <div class='baseInfoContent'>
              <el-table :data='operationData' border
                        :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}">
                <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                <el-table-column prop='operateType' label='操作类型' align='center' />
                <el-table-column prop='operationName' label='操作人' align='center' />
                <el-table-column prop='remark' label='备注' align='center' />
              </el-table>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import {
    lineConfigureIsEnable,
    lineConfigurePageList,
    lineConfigureAdd,
    lineConfigureUpdate,
    lineConfigDetail,
    vehicleDeployInfoCvGetTypeInfo,
    lineConfigListByAddr,
    lineConfigureDelete,
    supplierPublicSelectPort,
    supplierPublicSelectDistributor,
    lineConfigurePort,
  } from '@/service/vehiclelog';
  import {
    getSessionStore,
  } from '@/config/mUtils';
  import {baseUrl } from '@/config/env';
  import { applicationAreaInfo, getRegionName } from '@/service/getData';

  export default {
    components: {
      divBorder,
    },
    data() {
      let checkOvertime = (rule, value, callback) => {
        let fallEnd = this.$refs.selectValue ? this.$refs.selectValue.value : value;
        // const reg = new RegExp(/^\S$/)
        if (value && fallEnd) {
          callback();
        } else {
          if (!value) {
            callback(new Error('请输入预计耗时多少'));
          }
          if (!fallEnd) {
            callback(new Error('请选择预计耗时单位'));
          }
        }
      };
      return {
        form: {
          lineName: '',
          lineType: '',
          startAddressName: '',
          endAddressName: '',
          departurePort: '',
          arrivePort: '',
          status: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        stepList: [
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
        ],
        AddressMap: new Map(),

        startPortList: [],   // 起始地港口
        endPortList: [],   // 目的地港口
        addform: {
          lineName: '',//线路名称
          lineType: '',//线路类型
          startAddress: [],//起运地
          startAddressCoordinate: '',//起始地经纬度
          startPort: {},  // 起始地港口
          endAddress: [],//目的地
          endAddressCoordinate: '',//目的地经纬度
          endPort: {},  // 目的地港口
          estimateTime: '',//预计耗时
          distance: '',//距离
          repairContent: '',
        },
        detailData: {},
        operationData: [],
        detailDialogVisible: false,
        dialogTitle: '',
        // 1 为添加 2 修改
        dilogNumber: 1,
        addLoading: false,//添加加载
        addflag: false,
        modifyflag: false,
        cityList: JSON.parse(getSessionStore('areaList')),
        addressMap: new Map(),
        lineTypeList: [],
        rules: {
          lineName: {
            required: true,
            message: '请输入线路名称',
            trigger: 'blur',
          },

          lineType: {
            required: true,
            message: '请选择线路类型',
            trigger: 'blur',
          },
          startAddress: {
            required: true,
            message: '请选择起运地城市',
            trigger: 'blur',
          },
          endAddress: {
            required: true,
            message: '请选择目的地城市',
            trigger: 'blur',
          },
          estimateTime: {
            required: true,
            validator: checkOvertime,
            trigger: 'blur',
          },
          distance: [{
            required: true,
            message: '请输入距离',
            trigger: 'blur',
          },
            {
              pattern: /^([0-9]+\.?[0-9]*|-[0-9]+\.?[0-9]*)$/,
              message: '请输入数字',
            },
            {
              pattern: /^(\d+|\d+\.\d{1,2})$/,
              message: '最多两位小数',
            }, {
              pattern: /^\d{1,4}$/,
              message: '位数过多',
            }],
        },
      };

    },
    filters: {
      typeFilter(val) {
        let text = '';
        switch (val) {
          case 1:
            text = '公路';
            break;
          case 2:
            text = '水路';
            break;
          case 3:
            text = '水陆联运';
            break;
        }
        return text;
      },
      statusFilter(val) {
        let text = '';
        switch (val) {
          case 1:
            text = '启用中';
            break;
          case 0:
            text = '禁用中';
            break;
        }
        return text;
      },
    },
    created() {
      this.$nextTick(() => {
        this._lineConfigurePageList();
      });
    },
    watch: {
      endPortList(newVal, oldVal) {
        if (newVal != oldVal) {
          this.addform.endPort = '';
        }
      },
      startPortList(newVal, oldVal) {
        if (newVal != oldVal) {
          this.addform.startPort = '';
        }
      },
    },
    methods: {
      async _lineConfigurePageList() {
        this.tableLoad = true;
        let res = await lineConfigurePageList({
          ...this.form,
        });
        this.tableLoad = false;
        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 获取港口
      async getPort(type, val) {
        // let obj = {areaId:val};
        let res = await lineConfigurePort(val);
        if (res.status !== 0) return this.$message.error(res.message);
        if (type == 1) {
          this.endPortList = res.data;
        } else {
          this.startPortList = res.data;
        }
      },
      //区域下拉
      async applicationAreaInfo() {
        let res = await applicationAreaInfo();
        if (res.status !== 0) return this.$message.error(res.message);
        this.cityList = res.data;

      },
      async _vehicleDeployInfoCvGetTypeInfo(index) {
        if (index == 2) {
          let portRes = await supplierPublicSelectPort();
          if (portRes.status !== 0) return this.$message.error(portRes.message);
          return portRes.data;
        } else if (index == 3) {
          const res = await supplierPublicSelectDistributor();
          if (res.status !== 0) return this.$message.error(res.message);
          return res.data;
        }

      },
      searchBtn() {
        this.form.page = 1;
        this._lineConfigurePageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;

      },
      addBtn() {
        // 1 为添加 2 修改
        this.dilogNumber = 1;
        this.dialogTitle = '新增路线';
        this.addflag = true;
        this.addform = {
          lineName: '',//线路名称
          lineType: '',//线路类型
          startType: '',//起始类型
          startAddress: '',//起运地
          endAddress: '',//目的地
          arriveType: '',//到达类型
          estimateTime: '',//预计耗时
          distance: '',//距离
          repairContent: '',
        };
        // 获取区域下拉
        this.applicationAreaInfo();
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._lineConfigurePageList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._lineConfigurePageList();
      },
      // 删除
      deleteClick(row) {
        this.$confirm('确认要删除当前线路吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await lineConfigureDelete(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._lineConfigurePageList();
          })
          .catch(() => {
          });
      },
      // 启用
      EnableClick(row) {
        this.$confirm('确认要启用当前路线吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await lineConfigureIsEnable(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._lineConfigurePageList();
          })
          .catch(() => {
          });
      },
      // 禁用
      DisableClick(row) {
        this.$confirm('确认要禁用当前线路?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await lineConfigureIsEnable(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._lineConfigurePageList();

          })
          .catch(() => {
          });
      },
      // 新增/修改 —— 确认
      addClick() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$refs.ruleForm.validate(async (valid) => {
            // if(Object.keys(val).length === 1) valid=true;

            if (valid) {
              //水路联运数据处理
              let Object = {};
              const array = [];
              this.stepList.forEach((item, index) => {
                if (item.lineType !== null && item.lineType != '') {
                  let { lineType } = this.stepList[index];

                  Object = {
                    childId: lineType,
                    startAddressType: this.stepList[index - 1].address_type,
                    startAddressId: this.stepList[index - 1].Address.id,
                    startAddressName: this.stepList[index - 1].Address.name,
                    endAddressType: this.stepList[index + 1].address_type,
                    endAddressId: this.stepList[index + 1].Address.id,
                    endAddressName: this.stepList[index + 1].Address.name,
                    sortOrder: index,
                    // distance: this.addform.distance,
                    // estimateTime: this.addform.estimateTime,
                    // timeUnit: this.addform.repairContent,
                  };
                  array.push(Object);
                  console.log(Object);
                }
              });
              let {
                startAddressCoordinate,
                endAddressCoordinate,
                startAddress,
                endAddress,
                lineType,
              } = this.addform;

              //起始地 id逗号拼接
              let startId = '';
              let startName = '';
              let endId = '';
              let endName = '';
              //线路类型不等于水路联运
              if (lineType !== 3) {
                startAddress.forEach(item => {
                  startId += item + ',';
                });
                //去除末尾逗号
                startId = startId.slice(0, startId.length - 1);
                //获取区域名
                startName = await getRegionName(startId);

                endAddress.forEach(item => {
                  endId += item + ',';
                });
                endId = endId.slice(0, endId.length - 1);
                //获取区域名
                endName = await getRegionName(endId);
              }
              let data = {
                ...this.addform,
                //如果水路联运
                startAddressName: this.addform.lineType === 3 ? array[0].startAddressName : startName.data,
                startAddressId: this.addform.lineType === 3 ? array[0].startAddressId : startAddress[startAddress.length - 1],
                //不等于水路联运 保存级联下拉选择的所有id
                startFullAddressId: this.addform.lineType !== 3 ? startId : '',
                //水陆联运 通过索引1 lineType得到 起始详情位置
                // 起始地坐标
                startingCoordinate: this.addform.startType === 1 ? `${this.consignorMap.get(this.addform.startAddress[1]).longitude},${this.consignorMap.get(this.addform.startAddress[1]).latitude}` : startAddressCoordinate,

                endAddressName: this.addform.lineType === 3 ? array[array.length - 1].endAddressName : endName.data,
                endAddressId: this.addform.lineType === 3 ? array[array.length - 1].endAddressId : endAddress[endAddress.length - 1],
                //不等于水路联运 保存级联下拉选择的所有id
                endFullAddressId: this.addform.lineType !== 3 ? endId : '',
                //交车地坐标
                deliveryCoordinate: this.addform.arriveType === 1 ? `${this.consignorMap.get(this.addform.endAddress[1]).longitude},${this.consignorMap.get(this.addform.endAddress[1]).latitude}` : endAddressCoordinate,

                estimateTime: this.addform.estimateTime,
                timeUnit: this.addform.repairContent,
                childRelList: array,

                departurePortId: this.addform.startPort || '',  // 起运港口id
                departurePort: '',   // 起运港名
                arrivePortId: this.addform.endPort || '',    //到达港id
                arrivePort: '',   //到达港名
              };
              if (this.startPortList.length > 0 && this.addform.startPort) {
                data.departurePort = this.startPortList.filter(item => item.id == this.addform.startPort)[0].supplier_name;
              }
              if (this.endPortList.length > 0 && this.addform.endPort) {
                data.arrivePort = this.endPortList.filter(item => item.id == this.addform.endPort)[0].supplier_name;
              }
              console.log(getRegionName(startAddress.join(',')), getRegionName(endAddress.join(',')), data);
              // return false
              // 1 为添加 2 修改
              this.addLoading = true;
              let res = this.dilogNumber === 1 ? await lineConfigureAdd(data) : await lineConfigureUpdate(data);
              this.addLoading = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              await this._lineConfigurePageList();
              this.dialogClose();
            } else {
              return false;
            }
          });
        }, 600);
        // this.addflag = false
      },
      exportClick() {
        // let token = getSessionStore('token');
        // let url = baseUrl + '/platform/sys/lineConfig/lineExoprt';
        // // url += '?supplierName='+this.teamIpt;
        // url += '?lineName=' + this.form.lineName + '&startAddressName=' + this.form.startAddressName;
        // url += '&endAddressName=' + this.form.endAddressName + '&departurePort=' + this.form.departurePort;
        // url += '&arrivePort=' + this.form.arrivePort + '&status=' + this.form.status;
        // url += '&access_token=' + token;
        // window.location.href = url;
        window.exportExcelGet('/platform/sys/lineConfig/lineExoprt',
          'lineName=' + this.form.lineName + '&startAddressName=' + this.form.startAddressName +
          '&endAddressName=' + this.form.endAddressName + '&departurePort=' + this.form.departurePort +
          '&arrivePort=' + this.form.arrivePort + '&status=' + this.form.status
        )
      },
      dialogClose() {
        this.addflag = false;
        this.$refs.ruleForm.resetFields();
        for (const argumentsKey in this.addform) {
          this.addform[argumentsKey] = '';
        }
        this.startAddressList = [];
        this.endAddressList = [];
        this.stepList = [
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
        ];
      },
      // 修改
      async modifyClick(row) {
        // 1 为添加 2 修改
        this.dilogNumber = 2;
        this.dialogTitle = '修改线路';

        if (row.endAddressId) {
          let res2 = await lineConfigurePort(row.endAddressId);
          if (res2.status !== 0) return this.$message.error(res2.message);
          this.endPortList = res2.data;
        }
        if (row.startAddressId) {
          let res1 = await lineConfigurePort(row.startAddressId);
          console.log(res1);
          if (res1.status !== 0) return this.$message.error(res1.message);
          this.startPortList = res1.data;
          console.log(row);
        }
        let res = await lineConfigDetail({ id: row.id });
        if (res.status !== 0) return this.$message.error(res.message);
        let {
          childLineList,
          startFullAddressId,
          endFullAddressId,
        } = res.data;
        const stepList = [];
        if (childLineList && childLineList.length > 0) {
          childLineList.forEach((item, index) => {
            //如果为一说明只有一天 分为 三条 sortOrder为奇数 1 3 5  分别补充 0 2 4 6
            stepList[parseInt(item.sortOrder)] = {
              lineType: item.id,
              startType: '',
              Address: {
                name: item.startAddressName,
                id: item.startAddressId,
              },
            };
            stepList[parseInt(item.sortOrder) - 1] = {
              lineType: '',
              startType: item.lineName,
              Address: {
                name: item.startAddressName,
                id: item.startAddressId,
              },
              address_type: item.startAddressType,
            };
            stepList[parseInt(item.sortOrder) + 1] = {
              lineType: '',
              startType: item.lineName,
              Address: {
                name: item.endAddressName,
                id: item.endAddressId,
              },
              address_type: item.endAddressType,
            };
            //回显下拉框
            index === 0 ? lineConfigListByAddr()
              .then((value) => {
                this.$set(stepList[parseInt(item.sortOrder)], 'lineTypeList', value.data.map((item) => {
                  //使用Map存入数据
                  this.AddressMap.set(item.id, item);
                  return {
                    lineName: item.lineName,
                    lineType: item.lineType,
                    lineTypeStr: item.lineTypeStr,
                    id: item.id,
                  };
                }));                                                   // 去上一个的目的id
              })
              .catch(() => {
              }) : lineConfigListByAddr({ startAddrId: childLineList[index - 1].endAddressId })
              .then((value) => {
                this.$set(stepList[parseInt(item.sortOrder)], 'lineTypeList', value.data.map((item) => {
                  //使用Map存入数据
                  this.AddressMap.set(item.id, item);
                  return {
                    lineName: item.lineName,
                    lineType: item.lineType,
                    lineTypeStr: item.lineTypeStr,
                    id: item.id,
                  };
                }));
              })
              .catch(() => {
              });

          });
          // console.log(stepList)
          // this.$message.success(res.message)
        }
        let {
          estimateTime,
          timeUnit,
          endAddressId,
          startAddressId,
          departurePortId,
          arrivePortId,
        } = row;
        let startAddress = [],
          endAddress = [];
        if (startFullAddressId && startFullAddressId.indexOf(',') != -1) {
          startAddress = startFullAddressId.split(',');
          endAddress = endFullAddressId.split(',');
        } else {
          startAddress = startFullAddressId.split('/');
          endAddress = endFullAddressId.split('/');
        }
        this.addform = {
          ...row,
          startAddress: startAddress,
          endAddress: endAddress,
          // startAddress:startFullAddressId ? startFullAddressId.split(','): '',
          // endAddress:endFullAddressId ? endFullAddressId.split(",") : '',
          startPort: departurePortId,
          endPort: arrivePortId,
          estimateTime: estimateTime,
          // repairContent:estimateTime.slice(estimateTime.indexOf("(")+1,estimateTime.indexOf(")"))
          repairContent: timeUnit,
        };
        this.stepList = res.data.childLineList === null ? this.stepList : stepList;
        this.addflag = true;
      },

      async addStep() {
        this.stepList.forEach((item, index) => {
          if (!(index % 2 == 0)) {
            if (item.lineType === '') {
              this.$message.warning('请将路线填写完整');
              throw new Error('请将路线填写完整');
            }
          } else {

          }
        });
        //用存入的id
        let res = await lineConfigListByAddr({ startAddrId: this.stepList[this.stepList.length - 1].Address.id });
        this.stepList.push(
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
        );

        this.stepList[this.stepList.length - 2].lineTypeList = res.data.map((item) => {

          return {
            lineName: item.lineName,
            lineType: item.lineType,
            lineTypeStr: item.lineTypeStr,
            id: item.id,

          };
        });

      },
      //获取地区经纬度
      /**
       *
       * @param type 0 起始地区 1 目的地区
       * @param value 选择的值
       */
      handleChange(type, value) {
        this.$nextTick(() => {
          if (type == 1) { // 目的地区
            this.$forceUpdate();
            this.addform.endAddressCoordinate = this.$refs.cascader2.getCheckedNodes()[0].data.center;
            console.log(this.$refs.cascader2.getCheckedNodes()[0]);
            this.getPort(type, value[value.length - 1]);
          } else { //起始地区
            this.addform.startAddressCoordinate = this.$refs.cascader1.getCheckedNodes()[0].data.center;
            console.log(this.$refs.cascader1.getCheckedNodes()[0]);
            this.getPort(type, value[value.length - 1]);
          }
        });
      },
      clearStep() {
        if (this.stepList.length > 3) {
          this.stepList.splice(this.stepList.length - 1, 1);
          this.stepList.splice(this.stepList.length - 1, 1);
          console.log(this.stepList);
        }

      },
      async reset() {
        this.stepList = [
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
          {
            id: '',
            lineType: '',
            startType: '',
            Address: {
              name: '',
              id: '',
            },
            lineTypeList: [],
          },
        ];
        this.stepList.forEach((item, index) => {
          for (const itemKey in item) {
            item[itemKey] = '';
          }
        });
        let res = await lineConfigListByAddr();
        if (res.status !== 0) return this.$message.error(res.message);
        console.log(this.stepList[1].lineTypeList);
        this.stepList[1].lineTypeList = res.data.map((item) => {
          this.AddressMap.set(item.id, item);
          return {
            lineName: item.lineName,
            lineType: item.lineType,
            lineTypeStr: item.lineTypeStr,
            id: item.id,

          };
        });
      },
      async lineTypeChange(val) {
        for (const valKey in this.addform) {
          if (valKey !== 'lineName' && valKey !== 'lineType') {
            this.addform[valKey] = '';
            console.log(valKey);
          }
          // this.addform[valKey]=''
        }
        let res = await lineConfigListByAddr();
        // if (res.status !==0) return this.$message.error(res.message)
        console.log(this.stepList[1].lineTypeList);
        this.stepList[1].lineTypeList = res.data.map((item) => {
          //使用Map存入数据
          this.AddressMap.set(item.id, item);
          return {
            lineName: item.lineName,
            lineType: item.lineType,
            lineTypeStr: item.lineTypeStr,
            id: item.id,
          };
        });
        console.log(this.stepList);
        console.log(this.AddressMap);


      },
      async lineTypeSelectChange(id, index) {
        // index ===1 有下拉的列表  初始列表
        if (index === 1) this.stepList[index - 1].Address.name = this.AddressMap.get(id).startAddressName;
        if (index === 1) this.stepList[index - 1].Address.id = this.AddressMap.get(id).startAddressId;
        if (index === 1) this.stepList[index - 1].address_type = this.AddressMap.get(id).startAddressType;
        //下拉的 下一个列表
        this.stepList[index + 1].Address.name = this.AddressMap.get(id).endAddressName;
        this.stepList[index + 1].Address.id = this.AddressMap.get(id).endAddressId;
        this.stepList[index + 1].address_type = this.AddressMap.get(id).endAddressType;
        if (index === 1) this.stepList[index - 1].startType = this.AddressMap.get(id).lineName;
        this.stepList[index + 1].startType = this.AddressMap.get(id).lineName;

        //下面是否还有选项，赋值，清零
        if (this.stepList.length - 1 > index + 1) {
          let res = await lineConfigListByAddr({ startAddrId: this.stepList[index + 1].Address.id });
          this.stepList[index + 2].lineType = '';
          this.stepList[index + 2].lineTypeList = res.data.map((item) => {
            return {
              lineName: item.lineName,
              lineType: item.lineType,
              lineTypeStr: item.lineTypeStr,
              id: item.id,
            };
          });
        }


      },
      async handleItemChange(val) {
        console.log(this.$refs.areaCascader);
        console.log(val);
        let res = await vehicleDeployInfoCvGetTypeInfo(val);
        if (val.indexOf('1') > -1) {
          this.options2[0].cities = res.data.map((item) => {
            this.addressMap.set(item.id, item.address);
            return {
              value: item.id,
              label: item.address,
            };
          });
        } else if (val.indexOf('2') > -1) {
          debugger
          this.options2[1].cities = res.data.map((item) => {
            this.addressMap.set(item.id, item.address);
            return {
              value: item.id,
              label: item.address,
            };
          });
        } else if (val.indexOf('3') > -1) {
          this.options2[2].cities = res.data.map((item) => {
            this.addressMap.set(item.id, item.address);
            return {
              value: item.id,
              label: item.address,
            };
          });
        } else if (val.indexOf('4') > -1) {
          this.options2[3].cities = res.data.map((item) => {
            this.addressMap.set(item.id, item.address);
            return {
              value: item.id,
              label: item.address,
            };
          });
        }


      },
      // 详情
      async detailClick(row) {
        let res = await lineConfigDetail({ id: row.id });
        if (res.status !== 0) return this.$message.error(res.message);
        let { childLineList } = res.data;
        const stepList = [];
        if (childLineList && childLineList.length > 0) {
          childLineList.forEach((item, index) => {
            stepList[parseInt(item.sortOrder)] = {
              lineType: item.id,
              startType: '',
              Address: {
                name: item.startAddressName,
                id: item.startAddressId,
              },

            };
            stepList[parseInt(item.sortOrder) - 1] = {
              lineType: '',
              startType: item.lineName,
              Address: {
                name: item.startAddressName,
                id: item.startAddressId,
              },
              address_type: item.startAddressType,
            };
            stepList[parseInt(item.sortOrder) + 1] = {
              lineType: '',
              startType: item.lineName,
              Address: {
                name: item.endAddressName,
                id: item.endAddressId,
              },
              address_type: item.endAddressType,
            };
            index === 0 ? lineConfigListByAddr()
              .then((value) => {
                this.$set(stepList[parseInt(item.sortOrder)], 'lineTypeList', value.data.map((item) => {
                  return {
                    lineName: item.lineName,
                    lineType: item.lineType,
                    lineTypeStr: item.lineTypeStr,
                    id: item.id,
                  };
                }));
              })
              .catch(() => {
              }) : lineConfigListByAddr({ startAddrId: childLineList[index - 1].endAddressId })
              .then((value) => {
                this.$set(stepList[parseInt(item.sortOrder)], 'lineTypeList', value.data.map((item) => {
                  return {
                    lineName: item.lineName,
                    lineType: item.lineType,
                    lineTypeStr: item.lineTypeStr,
                    id: item.id,
                  };
                }));
              })
              .catch(() => {
              });

          });
        }
        this.detailData = res.data;
        this.operationData = res.data.operateRecordList;
        this.stepList = stepList;
        this.detailDialogVisible = true;
      },
      getStart(row) {
        console.log(row);
        if (row.lineType == 1) {
          if (row.departurePort) {
            return row.startAddressName + '【' + row.departurePort + '】';
          } else {
            return row.startAddressName;
          }
        } else {
          return (row.departurePort || '');
        }
      },
      getEnd(row) {
        if (row.lineType == 1) {
          if (row.arrivePort) {
            return row.endAddressName + '【' + row.arrivePort + '】';
          } else {
            return row.endAddressName;
          }
        } else {
          return (row.arrivePort || '');
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .logisticsConfig {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;

      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainerNav {
        font-size: 16px;
        text-decoration: underline;
      }

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    ::v-deep.add {
      padding: 26px 40px;

      .estimated {
        .input-with-select .el-input-group__prepend {
          background-color: #fff;
        }

        .el-select .el-input {
          width: 65px;
        }
      }

      .el-input {
        // width: 310px;
      }

      .el-form-item__label {
        /*color: #060606;*/
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 10px;

        .el-form-item__error {
          /*left: 41px;*/
          padding-top: 0px;
        }
      }

      .repair {
        padding: 10px;
        /*height: 200px;*/
        &Botem {
          display: flex;
          margin-left: 10px;
        }

        &Steps {
          margin-left: 40px;
          margin-top: 20px;

          .el-input {
            width: 137px;
          }

          .el-cascader {
            width: 59px;
          }


        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 25px;
      margin-top: 35px;

      button {
        margin: 0 15px;
      }
    }

    ::v-deep .detail {

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
              font-weight: 700;
            }
          }

          .repair {
            padding: 10px;
            /*height: 200px;*/
            &Botem {
              display: flex;
              margin-left: 10px;
            }

            &Steps {
              margin-left: 40px;
              margin-top: 20px;

              .el-input {
                width: 100px;
              }

              .el-cascader {
                width: 59px;
              }


            }
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      color: #606266;
      max-height: 75vh;
      overflow: auto;
    }

    form.el-form.demo-form-inline.flex1.el-form--inline {
      margin-bottom: 20px !important;
    }

    form.el-form.demo-form-inline.flex1 .el-form-item {
      margin-bottom: 0px !important;
    }
  }
</style>
